import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function EnvioExitoso() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const guia = searchParams.get('guia') || '';
  const paqueteria = searchParams.get('paqueteria') || '';
  const pdf = searchParams.get('pdf') || '';
  const costo = searchParams.get('costo') || '';

  useEffect(() => {
    if (!guia) {
      navigate('/mis-envios');
    }

    if (window.gtag && guia) {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-18011439275/P4Q2CKTxp5AcEKuBw4xD',
        'value': parseFloat(costo) || 0,
        'currency': 'MXN',
        'transaction_id': guia
      });
    }
  }, [guia, costo, navigate]);

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', backgroundColor: '#f8f9fb' }}>
      <div style={{ maxWidth: '520px', width: '100%', backgroundColor: '#fff', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '40px', textAlign: 'center' }}>
        
        {/* Check icon */}
        <div style={{ width: '72px', height: '72px', borderRadius: '50%', backgroundColor: '#e8f5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>

        <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#1a1a1a', margin: '0 0 8px' }}>
          ¡Tu guía está lista! 🎉
        </h1>
        
        <p style={{ fontSize: '15px', color: '#666', margin: '0 0 28px' }}>
          Tu envío ha sido creado exitosamente
        </p>

        {/* Shipment details */}
        <div style={{ backgroundColor: '#f8f9fb', borderRadius: '12px', padding: '20px', marginBottom: '24px', textAlign: 'left' }}>
          {paqueteria && (
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
              <span style={{ color: '#888', fontSize: '14px' }}>Paquetería</span>
              <span style={{ fontWeight: '600', fontSize: '14px' }}>{decodeURIComponent(paqueteria)}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
            <span style={{ color: '#888', fontSize: '14px' }}>No. de guía</span>
            <span style={{ fontWeight: '600', fontSize: '14px', fontFamily: 'monospace' }}>{guia}</span>
          </div>
          {costo && (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ color: '#888', fontSize: '14px' }}>Costo</span>
              <span style={{ fontWeight: '600', fontSize: '14px', color: '#2e7d32' }}>${parseFloat(costo).toFixed(2)} MXN</span>
            </div>
          )}
        </div>

        {/* Action buttons */}
        {pdf && (
          <a href={decodeURIComponent(pdf)} target="_blank" rel="noopener noreferrer"
             style={{ display: 'block', backgroundColor: '#ff8c00', color: '#fff', textDecoration: 'none', fontWeight: '700', fontSize: '15px', padding: '14px', borderRadius: '10px', marginBottom: '12px' }}>
            📄 Descargar guía PDF
          </a>
        )}

        <button onClick={() => navigate('/crear-envio')}
                style={{ display: 'block', width: '100%', backgroundColor: '#fff', color: '#ff8c00', border: '2px solid #ff8c00', fontWeight: '700', fontSize: '15px', padding: '12px', borderRadius: '10px', cursor: 'pointer', marginBottom: '12px' }}>
          Crear otro envío
        </button>

        <button onClick={() => navigate('/mis-envios')}
                style={{ display: 'block', width: '100%', backgroundColor: 'transparent', color: '#888', border: 'none', fontSize: '14px', padding: '8px', cursor: 'pointer', textDecoration: 'underline' }}>
          Ver mis envíos
        </button>

        {/* WhatsApp help */}
        <div style={{ marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #eee' }}>
          <p style={{ fontSize: '13px', color: '#999', margin: '0 0 8px' }}>¿Necesitas ayuda con tu envío?</p>
          <a href={'https://wa.me/526141964948?text=Hola%2C%20necesito%20ayuda%20con%20mi%20envío%20' + guia}
             target="_blank" rel="noopener noreferrer"
             style={{ display: 'inline-block', backgroundColor: '#25D366', color: '#fff', textDecoration: 'none', fontSize: '13px', fontWeight: '600', padding: '8px 20px', borderRadius: '8px' }}>
            💬 WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
